import { render } from "./ReviewModal.vue?vue&type=template&id=3d3a29b5&scoped=true"
import script from "./ReviewModal.vue?vue&type=script&lang=js"
export * from "./ReviewModal.vue?vue&type=script&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=3d3a29b5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3a29b5"]])

export default __exports__